import { render } from "./ReCeipt.vue?vue&type=template&id=708984b3&scoped=true"
import script from "./ReCeipt.vue?vue&type=script&lang=js"
export * from "./ReCeipt.vue?vue&type=script&lang=js"

import "./ReCeipt.vue?vue&type=style&index=0&id=708984b3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708984b3"]])

export default __exports__